/* eslint-disable react/prop-types */ // TODO: add props
import { useMemo } from 'react';
import Immutable from 'immutable';
import { Table } from 'edrolo/domains/teacherResultsTable';
import StudentRow from './StudentRow';
import { QUESTION_GROKKED } from '../../constants';

const QuestionTableBody = ({
  students,
  classExamSittings,
  sortColumn,
  sortAscending,
  getQuestionReviewUrl,
  flatQuestions,
  indicesToAddSpacerCellTo,
  showCorrectLayer,
  showIncorrectLayer,
  classId,
  navigatedFrom,
  analyticsPayload,
  highlightProfileId,
}) => {
  const tableData = useMemo(
    () =>
      students.map((student) => {
        const examSitting = classExamSittings.find(
          (sitting) => sitting.get('profile') === student.get('profile_id'),
          null,
          Immutable.Map()
        );
        const responses = examSitting.get('responses', Immutable.List());
        const totalUnderstands = responses.reduce(
          (acc, response) =>
            (acc += response.get('grokked') === QUESTION_GROKKED.YES ? 1 : 0),
          0
        );

        // add understands total to student map
        return student
          .set('totalUnderstands', totalUnderstands)
          .set('examSitting', examSitting);
      }),
    [students, classExamSittings]
  );

  const sortedTableData = useMemo(() => {
    let valueMapper;
    let comparator;
    switch (sortColumn) {
      case 'name': {
        valueMapper = (student) =>
          `${student.get('last_name')}-${student.get('display_name')}`;
        comparator = (a, b) => a.localeCompare(b);
        break;
      }
      case 'understands': {
        valueMapper = (student) => student.get('totalUnderstands');
        break;
      }
      default:
    }
    const columnSorted = tableData.sortBy(valueMapper, comparator);
    return sortAscending ? columnSorted : columnSorted.reverse();
  }, [tableData, sortColumn, sortAscending]);

  return (
    <Table.Body>
      {sortedTableData.toList().map((student) => (
        <StudentRow
          key={`profile-${student.get('profile_id')}`}
          studentName={student.get('display_name')}
          totalUnderstands={student.get('totalUnderstands')}
          profileId={student.get('profile_id')}
          userId={student.get('user_id')}
          classId={classId}
          examSitting={student.get('examSitting')}
          getQuestionReviewUrl={getQuestionReviewUrl}
          flatQuestions={flatQuestions}
          indicesToAddSpacerCellTo={indicesToAddSpacerCellTo}
          showCorrectLayer={showCorrectLayer}
          showIncorrectLayer={showIncorrectLayer}
          showUnderstood
          showName
          navigatedFrom={navigatedFrom}
          analyticsPayload={analyticsPayload}
          shouldHighlightRow={
            highlightProfileId
              ? highlightProfileId === student.get('profile_id')
              : false
          }
        />
      ))}
    </Table.Body>
  );
};
export default QuestionTableBody;
